import { useEffect } from 'react';
import { DataGridPro, GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import { ContextMenu } from './ContextMenu';
import { useRoundingRulesTable } from 'hooks/roundingRules/useRoundingRulesTable';

const Table = () => {
    const { t } = useTranslation();
    const { rows, loading, selectedRow, setSelectedRow, contextMenu, setContextMenu, selected, setSelected, columns, reloading } = useRoundingRulesTable();

    useEffect(() => {
        reloading();
    }, [reloading]);

    return (
        <div
            style={{ width: '100%', height: '100%' }}
            onContextMenu={(event) => {
                event.preventDefault();
                setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null);
            }}
        >
            <DataGridPro
                sx={{
                    height: 'calc(100vh - 140px)',
                    cursor: 'default',
                    '& .MuiDataGrid-cell': {
                        cursor: 'pointer',
                    },
                }}
                columns={columns}
                rows={rows}
                loading={loading}
                showCellVerticalBorder
                showColumnVerticalBorder
                headerFilters
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'name', sort: 'asc' }],
                    },
                }}
                localeText={{
                    headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                    headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                    headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                    headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                    headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                    headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                    footerRowSelected: (count: number) =>
                        count > 1 ? t('general.table.footerFilters.footerRowSelected.>1', { count }) : t('general.table.footerFilters.footerRowSelected.=1', { count }),
                    footerTotalRows: t('general.table.footerFilters.footerTotalRows'),
                    MuiTablePagination: {
                        labelDisplayedRows: ({ from, to, count }: { from: number; to: number; count: number }) => t('general.table.footerFilters.labelDisplayedRows', { from, to, count }),
                        labelRowsPerPage: t('general.table.footerFilters.labelRowsPerPage'),
                    },
                }}
                disableColumnMenu
                checkboxSelection
                rowSelectionModel={selected}
                onRowSelectionModelChange={(newRowSelectionModel: GridRowSelectionModel) => {
                    let row = rows.filter((row: any) => newRowSelectionModel.includes(row.id));
                    setSelected(newRowSelectionModel);
                    setSelectedRow(row);
                }}
                pagination
            />

            <ContextMenu contextMenu={contextMenu} setContextMenu={setContextMenu} selectedRow={selectedRow} reloading={reloading} rows={rows} />
        </div>
    );
};

export { Table };
